﻿import $ from 'jquery';

declare global{
  interface Event {
    dataTransfer: DataTransfer;
  }
  interface JQuery {
    filedragout: () => any;
  }
}

export class FileDragOut {
  static get wireup(): string {
    return '[data-filedragout]';
  }
}

function Plugin() {
  var $this = this;
  return $this.each(function () {
    $this.addClass('fdo-draggable');
    $this.attr('draggable', true);
  });
}

$.fn.filedragout = Plugin;

export interface DataTransfer {
  setData(prop: string, val: any): void;
}

interface Event {
  dataTransfer: DataTransfer;
}

$('[data-filedragout]').on('dragstart', function (e: JQueryEventObject) {
  var data = $(this).data();
  var completeUrl = 'application/octet-stream:' + data.filename + ':' + data.downloadurl;
  e.originalEvent.dataTransfer.setData('DownloadURL', completeUrl);
}).on('mousedown', function () { $(this).addClass('fdo-grabbing') })
  .on('mouseup dragend', function () { $(this).removeClass('fdo-grabbing') });

